<div id="Wrapper">
  <xform-banner-notifications></xform-banner-notifications>
  <xform-header></xform-header>
  <rms-release-splash-host></rms-release-splash-host>

  <div class="page-container">
    <router-outlet></router-outlet>

    <xform-spinner></xform-spinner>
    <!-- Disable tara chat icon -->
    <!--<rms-tara-icon></rms-tara-icon>-->
  </div>
</div>
